<div class="custom-color">
  <div class="preview">
    <div class="preview-background">
      <div class="circle" [style.width]="size + 'px'" [style.height]="size + 'px'" [class.colornull]="!color"
        [ngStyle]="{ background: color }"></div>
    </div>
  </div>
</div>
